// Schemas: SurveyBatch / SurveySubmission (verified against
// SCHEMA_REFERENCE.json). Sending a survey is modeled as one SurveyBatch
// insert plus one SurveySubmission insert per recipient (Angular's single
// POST /send call has no direct GraphQL-CRUD equivalent for a fan-out
// mutation).
export const INSERT_SURVEY_BATCH_MUTATION = `
  mutation InsertSurveyBatch($input: SurveyBatchInsertInput!) {
    insertSurveyBatch(input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const INSERT_SURVEY_SUBMISSION_MUTATION = `
  mutation InsertSurveySubmission($input: SurveySubmissionInsertInput!) {
    insertSurveySubmission(input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const DELETE_SURVEY_BATCH_MUTATION = `
  mutation DeleteSurveyBatch($filter: String!, $input: SurveyBatchDeleteInput!) {
    deleteSurveyBatch(filter: $filter, input: $input) {
      acknowledged
      totalImpactedData
    }
  }
`;

export const DELETE_SURVEY_SUBMISSION_MUTATION = `
  mutation DeleteSurveySubmission($filter: String!, $input: SurveySubmissionDeleteInput!) {
    deleteSurveySubmission(filter: $filter, input: $input) {
      acknowledged
      totalImpactedData
    }
  }
`;
